
function Navigate(path) {
    window.history.pushState({}, "", path);

    const navEvent = new PopStateEvent('popstate');
    window.dispatchEvent(navEvent);
}

export default Navigate;